import React, { lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { UserInfo } from "CommonLibrary";
import HealthFile from "../common/HealthFile";

const MassMailer = lazy(() => import("../component/screens/massMailer"));
const ApprovalRequest = lazy(() =>
	import("../component/containers/mmApprovalReqDetails/index")
);
const MassMailerNewRequest = lazy(() =>
	import("../component/containers/mmNewRequest/index")
);
const Approval = lazy(() =>
	import("../component/containers/approversGrid/index")
);
const ApproverDetails = lazy(() =>
	import("../component/containers/mmApproversDetails/index")
);
const MassEmailRequest = lazy(() =>
	import("../component/containers/mmSendMassEmailReqDetails/index")
);
const HelpDesk = lazy(() => import("../component/containers/helpDesk/index"));

// const LOGIN_ROOT = `${Environment.getLoginUrl()}`;
//const LOGIN_ROOT =`http://localhost:3000`;
// let {authUrl}=authTokenCookie();
// authUrl=(authUrl!==undefined) && authUrl.replace(`abs-url=${LOGIN_ROOT}`,``);

const route = (
	<React.Fragment>
		<Routes>
			<Route
				path="/approvalRequest"
				element={<ApprovalRequest />}
			/>
			<Route
				path="/massEmailRequest"
				element={<MassEmailRequest />}
			/>
			<Route path="/health" element={<HealthFile />} />
			<Route path="/approval" element={<Approval />} />
			<Route
				path="/approverDetails"
				element={<ApproverDetails />}
			/>
			<Route path="/" element={<MassMailer />} />
			<Route
				path="/massMailerNewRequest"
				element={<MassMailerNewRequest />}
			/>
			<Route path="/myinfo" element={<UserInfo />} />
			<Route path="/helpDesk" element={<HelpDesk />} />
		</Routes>
	</React.Fragment>
);

export default route;
